import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=a9062afc&scoped=true&"
import script from "./Manager.vue?vue&type=script&lang=ts&"
export * from "./Manager.vue?vue&type=script&lang=ts&"
import style0 from "./Manager.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Manager.vue?vue&type=style&index=1&id=a9062afc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9062afc",
  null
  
)

export default component.exports